import { useQuery } from '@tanstack/react-query';
import type { HealthResponse } from '../gen/openapi';
import { useApiClient } from './useApiClient';

export const useHealth = () => {
  const { health } = useApiClient();

  return useQuery<HealthResponse, Error>({
    queryKey: ['health'],
    queryFn: () => health.healthApiV1HealthGet(),
  });
};
